/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */

export enum ShippingTypes {
  air = 'Aéreo',
  pipeline = 'Dutoviário',
  rail = 'Ferroviário',
  waterway = 'Hidroviário',
  road = 'Rodoviário',
}
export enum HistoryTypes {
    Restore = 'Reativação da rota',
    Unproductive = 'Improdutiva',
    Occurrence = 'Ocorrência',
    Create = 'Criação da rota',
    Update = 'Alteração da rota',
    Disable = 'Desativação da rota',
    Execution = 'Nova execução da rota',
    NewActivity = 'Criação de uma atividade',
    UpdateActivity = 'Alteração de uma atividade',
    DeleteRoute = 'Remoção de uma atividade',
    StartActivity = 'Inicio de uma atividade',
    CompletedActivity = 'Finalização de uma atividade',
    CompletedOverdueActivity = 'Finalização atrasada de uma atividade',
    DispatchActivity = 'Despacho realizado',
    TranshipmentActivity = 'Transbordo realizado',
    CompletedRoute = 'Finalização de uma rota',
    SyncError = 'Erro de sincronização',
    FreightsSyncError = 'Erro de sincronização de uma ou mais cargas',
    ActivitySyncError = 'Erro de sincronização de uma atividade',
    RouteSyncError = 'Erro de sincronização de uma rota',
  }

export enum BatchTypes {
  Material = 'Material',
  Package = 'Pacote',
  Equipment = 'Equipamento',
}

export enum ActivityTypes {
  Delivery = 'Entrega',
  Collect = 'Coleta',
  Dispatch = 'Despacho',
  Transhipment = 'Transbordo',
}

export enum FrequencyTypes {
  Weekly = 'Semanal',
  Biweekly = 'Quinzenal',
  Single = 'Única',
  Monthly = 'Mensal no dia',
}

export enum PartnerTypes {
  Client = 'Cliente',
  Shipping = 'Transportadora',
  Supplier = 'Fornecedor',
  Airport = 'Aeroporto',
}

export enum VehicleContractTypes {
  Own = 'Próprio',
  Rented = 'Alugado',
  Partner = 'Parceiro',
}

export enum PackagingTypes {
    Refrigerated = 'Refrigerada',
    Enviroment = 'Ambiente',
    Frozen = 'Congelado',
  }

export enum DriverContractTypes {
  Own = 'Próprio',
  External = 'Externo',
}

export enum ChecklistTypes {
    Vehicles = 'Veícular',
    Motorcycle = 'Moto',
  }
export enum ChecklistFieldTypes {
    Image = 'Imagem',
    VehicleImage = 'Imagem do veículo',
    Breakdowns = 'Avarias',
    Checkbox = 'Caixa de seleção',
  }
export enum UserTypes {
  Driver = 'Condutor',
  Manager = 'Administrador',
}

export enum PermissionTypes {
  Blocked = 'Não editavel',
  Disallow = 'Não permitido',
  Related = 'Somente os relacionados',
  Allow = 'Permitido',
}

export enum AccessTypes {
  SuperUser = 'Super Usuário',
  Disallow = 'Não permitido',
  Related = 'Relacionados',
  Allow = 'Permitido',
}
export enum MethodTypes {
  SuperUser = 'superuser',
  View = 'view',
  Create = 'create',
  Update = 'update',
  disable = 'disable',
}

export enum RoleTypes {
  Default = 'Padrão',
  Custom = 'Personalizada',
}

export enum CompanyTypes {
  Main = 'Principal',
  Client = 'Cliente',
  Supplier = 'Fornecedor',
  Shipping = 'Transportadora',
  Airport = 'Aeroporto',
}

export enum TrainingTypes {
  User = 'user-trainings',
  Role = 'role-trainings',
  Driver = 'driver-trainings',
}
